import { createRequest, titanApi } from "./titanApi";

const extendedApi = titanApi
  .enhanceEndpoints({ addTagTypes: ["allEmailDistributionLists"] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAllDistributionLists: builder.query({
        query: () => ({
          ...createRequest(`/api/notification/distributionLists`),
          method: "GET",
        }),
        providesTags: ["allEmailDistributionLists"],
      }),

      updateDistributionList: builder.mutation({
        query: ({ id, data }) => ({
          ...createRequest(`/api/notification/distributionLists/${encodeURIComponent(id)}`),
          method: "PUT",
          body: { data },
        }),
        invalidatesTags: ["allEmailDistributionLists"],
      }),

      newDistributionList: builder.mutation({
        query: ({ data }) => ({
          ...createRequest("/api/notification/distributionLists"),
          method: "POST",
          body: { data },
        }),
        invalidatesTags: ["allEmailDistributionLists"],
      }),

      deleteDistributionList: builder.mutation({
        query: ({ id }) => ({
          ...createRequest(`/api/notification/distributionLists/${encodeURIComponent(id)}`),
          method: "DELETE",
          responseHandler: (response) => response.text(),
        }),
        invalidatesTags: ["allEmailDistributionLists"],
      }),
    }),

    // https://redux-toolkit.js.org/rtk-query/usage/code-splitting
    overrideExisting: false,
  });

export const {
  useGetAllDistributionListsQuery,
  useUpdateDistributionListMutation,
  useNewDistributionListMutation,
  useDeleteDistributionListMutation,
} = extendedApi;
